<template>
  <div class="sub-header">
    <img src="./../assets/cupshe.png" alt="" />
  </div>
  <div class="sub-content">
    <img
      class="m-banner"
      src="https://cdn-review.cupshe.com/shopify/resubscribe/sub_bg_pc.jpeg?x-oss-process=image/quality,q_100/format,avif"
      alt=""
    />
    <div class="contentBg" style="position: relative">
      <div class="loadingContent" v-if="loading">
        <img
          style="width: 90px; height: 90px"
          src="https://cdn-shopify.cupshe.com/shopify/aa2991ce-9d61-4fcd-a30e-83abdc12c13f/loading.gif"
          alt=""
          srcset=""
        />
      </div>
      <!-- 取消订阅成功 -->
      <div v-if="status === 'unSubscribeSuccess'" class="unSubscribeSuccess">
        <img src="./../assets/success_icon.png" alt="" srcset="" />
        <p class="successTitle">{{ t("subscribe1") }}</p>
        <p class="successQuestion">{{ t("subscribe2") }}</p>
        <button class="resubscribeBtn" @click="submit">
          {{ t("subscribe3") }}
        </button>
        <p class="subscribePolicy">{{ t("policyText") }}</p>
      </div>
      <!-- 取消订阅失败 -->
      <div v-if="status === 'unSubscribeError'" class="unSubscribeError">
        <img src="./../assets/warning_icon.png" alt="" srcset="" />
        <p class="errorText">{{ errorText }}</p>
        <p class="contact" v-html="t('mailContact')"></p>
      </div>
      <!-- 二次订阅成功 -->
      <div v-if="status === 'subscribeSuccess'" class="subscribeSuccess">
        <img
          class="subscribeImg"
          src="./../assets/thank_icon.png"
          alt=""
          srcset=""
        />
        <p class="subscribeTrust">{{ t("trustsubscribe") }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import { useI18n } from "vue-i18n";
import qs from "query-string";
import { defineComponent, reactive, toRefs, watch, onMounted } from "vue";
import { quickRegister, submitQuestions, resubscribe } from "../service/ums";
import {
  page_view,
  // button_click
} from "../utils/point";
export default defineComponent({
  setup() {
    const { t } = useI18n();
    const state = reactive({
      t,
      loading: false,
      success: false,
      error: false,
      errorText: "",
      status: "",
      imageUrl:
        "https://cdn-shopify.cupshe.com/shopify/57ed72bd-18f9-4498-85a3-e6b295189945/PC.jpg",
      unSubscribe: async () => {
        const href = location.href.split("?")[1];
        const query = qs.parse(href);
        let params = {
          userId: query.userId,
          sign: "",
          email: "",
          subscribeWay: 1,
          newsLetter: 0,
          triggerMode: 0,
          subscribeFrom: 3,
        }
        if(query.euid) {
          params.euidForCheck = query.euid;
        }
        if(query.tag) {
          params.tag = query.tag;
        }
        await quickRegister(params);
      },
      contentMsg: {},
      submit: async () => {
        const href = location.href.split("?")[1];
        const query = qs.parse(href);
        let params = {
          userId: query.userId,
          email: query.email,
          sign: query.sign,
          siteId: query.siteId || 1,
          terminalId: query.terminalId || 1,
          uid: query.id,
        }
        if(query.euid) {
          params.euidForCheck = query.euid;
        }
        if(query.tag) {
          params.tag = query.tag;
        }
        const { data } = await resubscribe(params);
        if (!data.success) {
          state.status = "unSubscribeError";
          if (data.retCode === "1000001") {
            state.errorText = t("You're already on the list!");
          } else {
            state.errorText = t("Oops, there was a hiccup!Please try again.");
          }
        } else {
          state.status = "subscribeSuccess";
        }
      },
      autoUnsubscribe: async (unsubscribe = false) => {
        state.loading = true;
        try {
          const href = location.href.split("?")[1];
          const query = qs.parse(href);
          const questions = state.contentMsg?.questions?.map((item) => ({
            questionId: item.questionId,
            answerIds:
              item.questionType === 1 ? [item.answerIds] : item?.answerIds,
            text: item?.text,
          }));
          const params = {
            brandId: 1,
            channelId: 1,
            terminalId: 1,
            siteId: query.siteId || 1,
            userId: query.userId,
            uid: query.id || query.uid,
            email: query.email,
            sign: query.sign,
            questions,
            unsubscribe,
          };
          if(query.euid) {
            params.euidForCheck = query.euid;
          }
          if(query.tag) {
            params.tag = query.tag;
          }
          const resData = await submitQuestions(params);
          let { success, retInfo } = resData.data;
          state.loading = false;
          // state.status = "subscribeSuccess";
          if (success) {
            state.status = "unSubscribeSuccess";
          } else {
            state.status = "unSubscribeError";
            state.errorText = retInfo;
          }
        } catch (e) {
          state.loading = false;
        }
      },
      isMobile() {
        return /Android|webOS|iPhone|iPod|BlackBerry/i.test(
          navigator.userAgent
        );
      },
      initPic: () => {
        //1 us 2: de 3: fr 4: es 5:it 6:au 21:pl 8: uk 9:ca 14: nz
        const href = location.href.split("?")[1];
        const query = qs.parse(href);
        const siteId = query.siteId;
        switch (siteId) {
          case "1":
            state.imageUrl = state.isMobile()
              ? "https://cdn-shopify.cupshe.com/shopify/2d508a19-792c-45d8-922b-0b067edfb92a/M.jpg"
              : "https://cdn-shopify.cupshe.com/shopify/57ed72bd-18f9-4498-85a3-e6b295189945/PC.jpg";
            break;
          case "2":
            state.imageUrl = state.isMobile()
              ? "https://cdn-shopify.cupshe.com/shopify/6dc98fa2-9b74-41fd-91ab-d376a1cddd75/686_206.jpg"
              : "https://cdn-shopify.cupshe.com/shopify/3d795b98-3317-4dd5-9a38-66a93818fca4/800_240.jpg";
            break;
          case "3":
            state.imageUrl = state.isMobile()
              ? "https://cdn-shopify.cupshe.com/shopify/8575c7fe-56c1-4df3-8465-d6b32edc0da5/画板 2.jpg"
              : "https://cdn-shopify.cupshe.com/shopify/26e9ff10-7041-46b0-a304-747d3e5a1f3f/画板 1 拷贝.jpg";
            break;
          case "8":
            state.imageUrl = state.isMobile()
              ? "https://cdn-shopify.cupshe.com/shopify/0e99c246-429c-4546-8826-dd9228dbec62/lQDPJx1c0lIojOvMzs0CrrDCu6Ce9gynqAV6zFTDr-IA_686_206.jpg"
              : "https://cdn-shopify.cupshe.com/shopify/60ffc672-111c-4d90-b6ce-ae2aaf4263d5/PC.jpg";
            break;
          case "21":
            state.imageUrl = state.isMobile()
              ? "https://cdn-shopify.cupshe.com/shopify/82e844f2-90de-4907-bd80-589e3a211ae1/m.jpg"
              : "https://cdn-shopify.cupshe.com/shopify/1a3d324a-cd0c-42aa-8c55-e21d904fc378/pc.jpg";
            break;
          case "26":
            state.imageUrl = state.isMobile()
              ? "https://cdn-shopify.cupshe.com/shopify/9e4665b9-3e41-45b8-8a92-2866d1f81318/m eu.jpg"
              : "https://cdn-shopify.cupshe.com/shopify/90aaf6c0-6d99-4573-a216-71bceb53233d/pc eu.jpg";
            break;
          case "9":
            state.imageUrl = state.isMobile()
              ? "https://cdn-shopify.cupshe.com/shopify/1aa20ddc-eed9-4c9d-8f11-56c29f036413/686-206.jpg"
              : "https://cdn-shopify.cupshe.com/shopify/7df13688-e20b-4f85-a254-de25378eb178/800-240.jpg";
            break;
          case "14":
            state.imageUrl = state.isMobile()
              ? "https://cdn-shopify.cupshe.com/shopify/531a078c-3d43-415a-bd48-dcf8d386bba3/m.jpg"
              : "https://cdn-shopify.cupshe.com/shopify/d2ea1224-f8be-483d-97c0-eaee7f6303ee/pc.jpg";
            break;
          case "6":
            state.imageUrl = state.isMobile()
              ? "https://cdn-shopify.cupshe.com/shopify/50819382-ed02-435d-af5b-2885d1f92c22/au-new-m.jpg"
              : "https://cdn-shopify.cupshe.com/shopify/9843cef3-342e-4b69-b7be-02595eaf5c93/au-newpc.jpg";
            break;
        }
      },
    });
    onMounted(() => {
      // state.unSubscribe();
      page_view();
      // state.initPic();
      state.autoUnsubscribe(true);
      // state.getQuestionsList();
    });
    watch(
      () => state.error,
      (newVal) => {
        if (newVal) {
          setTimeout(() => {
            state.error = false;
          }, 2000);
        }
      }
    );
    return {
      ...toRefs(state),
    };
  },
});
</script>
<style lang="less">
p {
  margin: 0;
}

.mainHeadAbove {
  font-size: 15px;
  font-family: "Avenir Next LT Pro 800" !important;
}

.mainHeadBelow {
  font-size: 12px;
  font-family: "Avenir Next LT Pro 500";
}

.title {
  font-size: 12px;
  font-family: "Avenir Next LT Pro 700";
}

@media (max-width: 768px) {
  .loadingContent {
    text-align: center;
  }
  .contentBg {
    margin-top: 60px;
    text-align: center;
    padding: 0 24px;
    img {
      width: 44px;
      height: 44px;
      margin-bottom: 14px;
    }
    .errorText {
      font-size: 14px;
      line-height: 18px;
      color: #1f1f1f;
      font-family: "Avenir Next LT Pro 500";
      margin-bottom: 4px;
    }
    .contact {
      font-size: 14px;
      line-height: 18px;
      color: #1f1f1f !important;
      font-family: "Avenir Next LT Pro 500";

      .contact_link {
        text-decoration: underline;
        color: #1f1f1f;
      }
    }
    .successTitle {
      font-size: 14px;
      line-height: 20px;
      font-family: "Avenir Next LT Pro 500";
      color: #1f1f1f;
      margin-bottom: 40px;
    }
    .successQuestion {
      font-size: 14px;
      line-height: 18px;
      font-family: "Avenir Next LT Pro 500";
      color: #666;
      margin-bottom: 24px;
    }
    .resubscribeBtn {
      font-size: 14px;
      line-height: 18px;
      letter-spacing: 1px;
      color: #ffffff !important;
      font-family: "Avenir Next LT Pro 800";
      background: #1f1f1f;
      padding: 13px 75px;
      border-radius: 4px;
      border: none;
      margin-bottom: 24px;
    }
    .subscribePolicy {
      font-size: 12px;
      line-height: 14px;
      color: #999999;
      font-family: "Avenir Next LT Pro 400";
    }
    .subscribeImg {
      width: 66px;
      height: auto;
    }
    .subscribeTrust {
      font-size: 14px;
      line-height: 20px;
      color: #1f1f1f;
      font-family: "Avenir Next LT Pro 500";
    }
  }
  .sub-header {
    text-align: center;

    img {
      height: 45px;
      margin-top: 6px;
      margin-bottom: 8px;
    }
  }

  .questions-content {
    width: 100%;
    height: calc(100% -101px);

    .m-banner {
      width: 100%;
    }

    .question {
      padding: 34px 16px;
    }

    .mainHeadBelow {
      margin-top: 8px;
    }

    .divider {
      margin: 16px 0;
      width: 100%;
      height: 1px;
      background-color: #f2f2f2;
    }

    .tipImg {
      width: 100%;
      height: 103px;
    }

    .question-answer {
      margin-top: 32px;

      .answerValue {
        font-size: 12px;
        font-family: "Avenir Next LT Pro 400";
      }
    }

    .subHeadAbove {
      font-size: 15px;
      font-family: "Avenir Next LT Pro 800";
      margin-top: 40px;
    }

    .subHeadBelow {
      font-size: 12px;
      font-family: "Avenir Next LT Pro 500";
    }

    // overflow-y: auto;
  }

  .sub-content {
    .m-banner {
      width: 100%;
    }
  }

  .sub-box {
    margin-top: 40px;
    padding: 0 24px;
    text-align: center;

    .success-icon {
      width: 60px;
      height: auto;
      margin-bottom: 24px;
    }

    .success-tips {
      color: #00b45a !important;
    }

    .box-title {
      font-family: "Avenir Next LT Pro 500";
      font-size: 14px;
      line-height: 21px;
      text-align: center;
      margin-bottom: 40px;
      color: #1f1f1f;
    }

    .box-tips {
      color: #1f1f1f;
      text-align: center;
      font-family: "Avenir Next LT Pro 400";
      font-size: 14px;
      line-height: 21px;
    }

    .box-button {
      text-align: center;
      box-sizing: border-box;
      width: 260px;
      padding: 15px 20px;
      text-align: center;
      margin: 0 auto;
      background-color: #000;
      color: #ffffff;
      letter-spacing: 1px;
      font-family: "Avenir Next LT Pro 800";
    }
  }
}

@media (min-width: 768px) {
  .loadingContent {
    img {
      margin-bottom: 0px;
    }
  }
  .m-banner {
    display: none;
  }
  .sub-header {
    background-color: #ffffff;
    text-align: center;

    img {
      padding-top: 16px;
      padding-bottom: 20px;
      height: 62px;
    }
  }
  .contentBg {
    background-color: #fff;
    padding: 80px 40px;
    text-align: center;
    width: 500px;
    img {
      width: 58px;
      height: 58px;
      margin-bottom: 24px;
    }
    .errorText {
      font-size: 18px;
      line-height: 24px;
      color: #1f1f1f;
      font-family: "Avenir Next LT Pro 500";
    }
    .contact {
      font-size: 18px;
      line-height: 24px;
      color: #1f1f1f !important;
      font-family: "Avenir Next LT Pro 500";

      .contact_link {
        text-decoration: underline;
        color: #1f1f1f;
      }
    }
    .successTitle {
      font-size: 18px;
      line-height: 24px;
      color: #1f1f1f !important;
      font-family: "Avenir Next LT Pro 500";
      margin-bottom: 60px;
    }
    .successQuestion {
      font-size: 16px;
      line-height: 20px;
      color: #666666 !important;
      font-family: "Avenir Next LT Pro 500";
      margin-bottom: 24px;
    }
    .resubscribeBtn {
      font-size: 14px;
      line-height: 18px;
      letter-spacing: 1px;
      color: #ffffff !important;
      font-family: "Avenir Next LT Pro 800";
      background: #1f1f1f;
      padding: 15px 75px;
      border-radius: 4px;
      border: none;
      margin-bottom: 24px;
    }
    .subscribePolicy {
      font-size: 12px;
      line-height: 14px;
      color: #999999;
      font-family: "Avenir Next LT Pro 400";
    }
    .subscribeTrust {
      font-size: 16px;
      line-height: 24px;
      color: #1f1f1f !important;
      font-family: "Avenir Next LT Pro 500";
    }
    .subscribeImg {
      width: 120px;
      height: auto;
    }
  }

  .questions-content {
    width: 100%;
    // height: calc(100vh - 275px);
    background: url(https://cdn-review.cupshe.com/shopify/resubscribe/sub_bg_pc.jpeg?x-oss-process=image/quality,q_100/format,avif)
      no-repeat;
    background-size: cover;
    background-position: center;
    display: flex;
    justify-content: center;
    padding: 56px 0 118px 0;

    .tipImg {
      width: 400px;
      height: 120px;
    }

    .question {
      width: 700px;
      padding: 40px;
      background: #fff;
      .mainHeadAbove {
        font-size: 15px;
        font-family: "Avenir Next LT Pro 800" !important;
      }

      .mainHeadBelow {
        font-size: 12px;
        font-family: "Avenir Next LT Pro 500";
      }

      .title {
        font-size: 12px;
        font-family: "Avenir Next LT Pro 700";
      }

      .divider {
        margin: 16px 0;
        width: 100%;
        height: 1px;
        background-color: #f2f2f2;
      }

      .question-answer {
        margin-top: 32px;

        .answerValue {
          font-size: 12px;
          font-family: "Avenir Next LT Pro 400";
        }
      }

      .subHeadAbove {
        font-size: 15px;
        font-family: "Avenir Next LT Pro 800";
        margin-top: 40px;
      }

      .subHeadBelow {
        font-size: 12px;
        font-family: "Avenir Next LT Pro 500";
      }
    }
  }

  .sub-content {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: calc(100vh - 101px);
    background: url(https://cdn-review.cupshe.com/shopify/resubscribe/sub_bg_pc.jpeg?x-oss-process=image/quality,q_100/format,avif)
      no-repeat;
    background-size: cover;
    background-position: center;

    .sub-box {
      width: 580px;
      padding: 60px 30px 68px 30px;
      background-color: #ffffff;
      box-sizing: border-box;
      text-align: center;

      .success-icon {
        width: 60px;
        padding-top: 20px;
        margin-bottom: 32px;
      }

      .success-tips {
        color: #00b45a !important;
      }

      .box-title {
        font-family: "Avenir Next LT Pro 500";
        font-size: 18px;
        color: #1f1f1f;
        text-align: center;
        line-height: 30px;
        margin-bottom: 60px;
        text-transform: capitalize;
      }

      .box-tips {
        font-family: "Avenir Next LT Pro 500";
        font-size: 18px;
        color: rgba(102, 102, 102, 1);
        text-align: center;
        line-height: 20px;
        margin-bottom: 24px;
        text-transform: capitalize;
      }

      .box-button {
        font-family: "Avenir Next LT Pro 800";
        font-size: 14px;
        color: #ffffff;
        text-align: center;
        background-color: #000;
        width: 260px;
        padding: 16px 0px;
        display: inline-block;
        letter-spacing: 1px;
        cursor: pointer;
      }
    }
  }
}
</style>
